import { EditText } from '../../ui/edit-text/edit-text';
import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';

export interface FilterGetFilterComponentDataModel {
  key: string;
  filterType: 'calendar_year' | 'text';
  title: string;
  filterKey: string;
  value: any;
  onChange: (key: string, value: any) => void;
}
export const FilterGetFilterComponenet: React.FC<
  FilterGetFilterComponentDataModel
> = ({ key, filterType, title, filterKey, value, onChange }) => {
  const [value1, setValue1] = useState();

  const getFilterComponent = () => {
    switch (filterType) {
      case 'text':
        return (
          <EditText
            width={'220px'}
            title={title}
            value={value || ''}
            onChange={(newValue) => onChange(filterKey, newValue)}
          />
        );

      case 'calendar_year':
        return (
          <div>
            <label style={{ fontSize: '14px', color: '#4b5563' }}>
              {title}
            </label>
            <Calendar
              id="buttondisplay"
              style={{
                height: '36px',
                minWidth: '220px',
                direction: 'ltr',
                marginTop: '4px',
                marginBottom: '16px',
              }}
              showButtonBar={true}
              onChange={(value) => {
                setValue1(value.value);
                onChange(filterKey, value.value);
              }}
              value={value1}
              onClearButtonClick={() => setValue1(undefined)}
              showIcon={true}
              inputStyle={{ direction: 'rtl' }}
              yearNavigator={true}
              view="year"
              dateFormat="yy"
              iconPos={'right'}
              yearRange={'1900:2024'}
            />
          </div>
        );
    }
  };

  return <div>{getFilterComponent()}</div>;
};
